import React from "react"
import { DEFAULT_SIZE } from "utils/icons"

const ChevronUpIcon = ({ 
    size = DEFAULT_SIZE, 
    color = "currenColor" 
}) => {
	return (
		<svg 
            xmlns="http://www.w3.org/2000/svg" 
            height={size} 
            width={size} 
            viewBox="0 0 128 128" 
            aria-hidden="true"
        >
           <path fill={color} d="M104 88a3.988 3.988 0 0 1-2.828-1.172L64 49.656 26.828 86.828c-1.563 1.563-4.094 1.563-5.656 0s-1.563-4.094 0-5.656l40-40a3.997 3.997 0 0 1 5.656 0l40 40a3.997 3.997 0 0 1 0 5.656A3.988 3.988 0 0 1 104 88z"/>
        </svg>
	)
}

export default ChevronUpIcon
